import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { IDetails } from './model/IDetails';

@Component({
  selector: 'app-detail-header-by-id',
  templateUrl: './detail-header-by-id.component.html',
  styleUrls: ['./detail-header-by-id.component.scss']
})
export class DetailHeaderByIdComponent implements OnInit {

  @Input() DetailHeader:IDetails;
  @Output() onCancel = new EventEmitter<any>();
  @Input() data: any;
  @Input() RowArray:  any[] = [];
  TableHeader:any=[];
  
  constructor() { }

  ngOnInit() {
    console.log("DetailHeaderByIdComponent",this.RowArray);
  }
    
  ngOnChanges(changes: SimpleChanges) {
    if (changes['RowArray'] && this.RowArray && this.RowArray.length > 0) {
      console.log('RowArray data received:', this.RowArray);
      this.TableHeader = Object.keys(this.RowArray[0]);
    }
  }

  openPhoneHyperLink(phone: any) {
    const phoneLink = "tel:+" + phone;
    window.location.href = phoneLink;
  }

  cancelClicked(){
    this.onCancel.emit();
  }
}
